import moment from 'moment';

const dataPickerPresets = {
    range: {
        'Today': [],
        'Yesterday': [],
        'Last 3 days': [],
        'Last 7 days': [],
        'Last 14 days': [],
        'Last 30 days': [],
        'This week': [],
        'This month': [],
        'Last month': [],
        'This year': [],
        'Last year': [],
    },
};

export const getCustomRange = function (dates) {
    return {
        text: 'Custom Range',
        dates: [
            new Date(moment(dates.start).format('YYYY-MM-DDTHH:mm:ss')),
            new Date(moment(dates.end).format('YYYY-MM-DDTHH:mm:ss')),
        ],
        onClick: () => {
            this.$nextTick(() => {
                this.shortcutClicked('Custom Range', -1);
            });
            return null;
        },
    };
};
export const getSinceRange = function (offset) {
    return {
        text: 'Since',
        dates: [
            new Date(moment().subtract(offset, 'minutes').startOf('day').format('YYYY-MM-DDTHH:mm:ss')),
            new Date(moment().subtract(offset, 'minutes').endOf('day').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
        ],
        onClick: () => {
            this.$nextTick(() => {
                this.shortcutClicked('Since', -1);
            });
            return null;
        },
    };
};

export const setDataTimePresets = function (offset = 0) {
    dataPickerPresets.range['Today'] = [
        new Date(moment().subtract(offset, 'minutes').startOf('day').format('YYYY-MM-DDTHH:mm:ss')),
        new Date(moment().subtract(offset, 'minutes').endOf('day').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
    ];
    dataPickerPresets.range['Yesterday'] = [
        new Date(moment().subtract(offset, 'minutes').subtract(1, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss')),
        new Date(moment().subtract(offset, 'minutes').endOf('day').subtract(1, 'days').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
    ];
    dataPickerPresets.range['Last 3 days'] = [
        new Date(moment().subtract(offset, 'minutes').startOf('day').subtract(2, 'days').format('YYYY-MM-DDTHH:mm:ssZ')),
        new Date(moment().subtract(offset, 'minutes').endOf('day').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
    ];
    dataPickerPresets.range['Last 7 days'] = [
        new Date(moment().subtract(offset, 'minutes').startOf('day').subtract(6, 'days').format('YYYY-MM-DDTHH:mm:ssZ')),
        new Date(moment().subtract(offset, 'minutes').endOf('day').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
    ];
    dataPickerPresets.range['Last 14 days'] = [
        new Date(moment().subtract(offset, 'minutes').startOf('day').subtract(13, 'days').format('YYYY-MM-DDTHH:mm:ssZ')),
        new Date(moment().subtract(offset, 'minutes').endOf('day').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
    ];
    dataPickerPresets.range['Last 30 days'] = [
        new Date(moment().subtract(offset, 'minutes').startOf('day').subtract(29, 'days').format('YYYY-MM-DDTHH:mm:ssZ')),
        new Date(moment().subtract(offset, 'minutes').endOf('day').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
    ];
    dataPickerPresets.range['This week'] = [
        new Date(moment().startOf('isoWeek').format('YYYY-MM-DDTHH:mm:ss')),
        new Date(moment().endOf('day').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
    ];
    dataPickerPresets.range['This month'] = [
        new Date(moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss')),
        new Date(moment().endOf('day').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
    ];
    dataPickerPresets.range['Last month'] = [
        new Date(moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DDTHH:mm:ss')),
        new Date(moment().subtract(1, 'month').endOf('month').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
    ];
    dataPickerPresets.range['This year'] = [
        new Date(moment().startOf('year').format('YYYY-MM-DDTHH:mm:ss')),
        new Date(moment().endOf('day').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
    ];
    dataPickerPresets.range['Last year'] = [
        new Date(moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DDTHH:mm:ss')),
        new Date(moment().subtract(1, 'year').endOf('year').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss')),
    ];
};

export const getDataTimeRangePresets = function () {
    const presets = [];
    Object.entries(dataPickerPresets.range).forEach(([key, value], index) => {
        presets.push({
            text: key,
            dates: value,
            onClick: () => {
                this.$nextTick(() => {
                    this.choosePreset(key, index);
                });
                return null;
            },
        });
    });
    return presets;
};

export const getObjectFromArray = function (dateArray, utc) {
    return {
        start: formatDate(dateArray[0], utc),
        end: formatDate(dateArray[1], utc),
    };
};

export const formatDate = function (date, utc) {
    if (utc) {
        return moment(date).format('YYYY-MM-DDTHH:mm:ss') + '+00:00';
        // return moment(date).format();
    }
    return moment(date).format();
};

export const formatWithOnlyDate = function (date) {
    return moment(date).format('YYYY/MM/DD');
};

export const getDateWithoutTime = function (date) {
    return {
        start: formatWithOnlyDate(date.start),
        end: formatWithOnlyDate(date.end),
    };
};

export const getTimeWithoutDate = function (date) {
    const time = {
        start: {
            hour: moment(date.start.split('+')[0]).format('HH'),
            minute: moment(date.start.split('+')[0]).format('mm'),
        },
        end: date.end ? {
            hour: moment(date.end.split('+')[0]).format('HH'),
            minute: moment(date.end.split('+')[0]).format('mm'),
        } : null,
    };
    return time;
};

export const getDateDif = function (date1, date2) {
    return moment(date1).diff(moment(date2), 'days') + 1;
};

export const getPrecisionFormat = function (precision) {
    let format = 'MMM DD,YYYY';
    if (precision === 'month') {
        format = 'MMM ,YYYY';
    } else if (precision === 'quarter') {
        format = '[Q]Q YYYY';
    } else if (precision === 'year') {
        format = 'YYYY';
    } else if (precision === 'hour') {
        format = 'HH:MMM DD,YYYY';
    }
    return format;
};

export const updateTimeHistory = function (dateTime, oldHistory) {
    const newDateTime = _.cloneDeep(dateTime);
    const newHistory = _.cloneDeep(oldHistory);
    newHistory.push(newDateTime);
    return newHistory.slice(-3);
};

